import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './Shimmer.scss';

const ShimmerRow = ({ inTaggingMode, odd }) => {
  return (
    <div className={cn('users row shimmer-row', { odd })}>
      {inTaggingMode ? (
        <>
          <div className='cell xs'>
            <div className='shimmer-cell xs' />
          </div>
          <div className='cell lg'>
            <div className='shimmer-cell lg' />
          </div>
          <div className='cell lg'>
            <div className='shimmer-cell lg' />
          </div>
          <div className='cell lg'>
            <div className='shimmer-cell lg' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell xl'>
            <div className='shimmer-cell xl' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell xl'>
            <div className='shimmer-cell xl' />
          </div>
        </>
      ) : (
        <>
          <div className='cell sm'>
            <div className='shimmer-cell sm' />
          </div>
          <div className='cell lg'>
            <div className='shimmer-cell lg' />
          </div>
          <div className='cell lg'>
            <div className='shimmer-cell lg' />
          </div>
          <div className='cell lg'>
            <div className='shimmer-cell lg' />
          </div>
          <div className='cell sm'>
            <div className='shimmer-cell sm' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell sm'>
            <div className='shimmer-cell sm' />
          </div>
          <div className='cell sm'>
            <div className='shimmer-cell sm' />
          </div>
          <div className='cell xs'>
            <div className='shimmer-cell xs' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell sm'>
            <div className='shimmer-cell sm' />
          </div>
          <div className='cell md'>
            <div className='shimmer-cell md' />
          </div>
          <div className='cell sm'>
            <div className='shimmer-cell sm' />
          </div>
          <div className='cell sm'>
            <div className='shimmer-cell sm' />
          </div>
        </>
      )}
    </div>
  );
};

ShimmerRow.propTypes = {
  inTaggingMode: PropTypes.bool,
  odd: PropTypes.bool
};

export default ShimmerRow;
